import React from "react";
import { TextField } from "@mui/material";

const DateInput = ({ label, value, onChange }) => {
  return (
    <TextField
      label={label}
      type="date"
      value={value ? value.substring(0, 10) : ""}
      onChange={(e) => onChange(e.target.value)}
      InputLabelProps={{
        shrink: true,
      }}
      size="small"
      sx={{ minWidth: 150 }}
    />
  );
};

export default DateInput;
